/* eslint-disable no-process-env */
/* eslint-disable camelcase */
/* eslint-disable id-match */
/* eslint-disable */
import { axios, V3, V1 } from './config';
import qs from 'qs';

const getStyle = (customerId) =>
  axios.get(`${V1}/event/css`, { params: { account_id: customerId } });

const getV2Styles = (customerId) => {
  return axios.get(`${V1}/chat/css`, {
    params: { id: customerId, v2: true },
  });
};

const getConfig = () => axios.get(`${V1}/chat/text`);

const getJobChatReadyStatus = (customerId, threadId) =>
  axios.get(`${V1}/jobchat/jc_chats`, {
    params: {
      account_id: customerId,
      filter: `[{"fieldName":"threadId","type":"Equals","value":"${threadId}"},{"fieldName":"jobChatReady","type":"Equals","value":true}]`,
    },
  });

const initialize = ({ jobChatId, firstName, lastName, phoneNumber, extras = {} }) =>
  axios.get(`${V3}/jobchat/initiate`, {
    params: {
      id: jobChatId,
      first_name: firstName,
      last_name: lastName,
      phone: phoneNumber,
      data: { jobId: extras.icimsJobId },
    },
  });

const initializeAnonWithFirstMessage = (initialCandidateMessage) =>
  axios.get(`${V3}/jobchat/transaction/initiate`, {
    // first_name, last_name, and phone are required params due to some backend complexities.
    params: {
      first_name: '',
      last_name: '',
      phone: '',
      text: initialCandidateMessage,
      send_first_message: Boolean(initialCandidateMessage),
      chat_ready: true,
    },
  });

// TODO: remove the text from query params once backend is updated
const sendAnonMessage = ({ text, jobChatId, }) =>
  axios.post(`${V3}/jobchat/send_message?${qs.stringify({text})}`, {
    text,
    jobchat_uuid: jobChatId,
  }
);  

// TODO: remove the data from query params once backend is updated
const sendMessage = ({ firstName, lastName, phoneNumber, text, jobChatId }) =>
  axios.post(`${V3}/jobchat/send_message?${qs.stringify(
    {
      text,
      first_name: firstName,
      last_name: lastName,
      phone: phoneNumber,
    })
  }`, 
  {
    text,
    jobchat_uuid: jobChatId,
  }
);

const getMessages = ({ jobChatId, candidateId }) =>
  axios.get(`${V3}/jobchat/get_messages`, {
    params: {
      id: jobChatId,
      candidate_id: candidateId,
    },
  });

const addCandidate = ({ firstName, lastName, phoneNumber }) =>
  axios.post(
    `${V1}/candidate/add?${qs.stringify({
      first_name: firstName,
      last_name: lastName,
      phone: phoneNumber,
    })}`,
  );

const uploadCandidateResume = ({ file, sequenceId }) => {
  const params = {
    sequence_id: sequenceId,
  };
  const url = `${V1}/jobchat/candidate/resume?${qs.stringify(params)}`;
  const formData = new FormData();
  formData.append('file', file[0]);
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'application/pdf',
    },
  });
};

const novaFeedback = ({ messageId, messageFeedback }) => {
  const params = {
    message_id: messageId,
    message_feedback: JSON.stringify(messageFeedback),
  };
  return axios.post(`${V1}/ai/feedback?${qs.stringify(params)}`);
};

export const Api = {
  getStyle,
  initialize,
  initializeAnonWithFirstMessage,
  sendMessage,
  getMessages,
  addCandidate,
  getV2Styles,
  getConfig,
  getJobChatReadyStatus,
  sendAnonMessage,
  uploadCandidateResume,
  novaFeedback,
};
